
import React, { useEffect, useState } from "react";
import HeaderSession from "../../../utils/headerSession";
import { Container, Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import Loading from "../../../load/loading";
import api from "../../../services/api";
import RegisterAccess from "../../../utils/registerAccess";
import { makeStyles } from "@material-ui/core";
import NavLateral from "./navLateral";
import { useSelector } from "react-redux";
import ProcessoLoading from "../../../load/processoLoading";


const useStyles = makeStyles((theme) => ({
    grid1: {
        width: 300,
        marginBottom: 15,
        marginLeft: 'auto',
        marginRight: 'auto',

        [theme.breakpoints.up('md')]: {
            // width: '100%',
            height: '100%',
            position: 'sticky',
            top: 70,
        },
    },
    grid2: {
        flexGrow: 1,
        marginLeft: 15,
        // minHeight: '100vh',
        width: 500,
        zIndex: 1,
        // position: 'relative',
    }
}))

export default function GestFarmacovigilancia({ element: component, ...rest }) {
    const alert = useSelector(state => state.alert.data);
    const { id } = useParams()
    const { produtoId } = useParams()
    // const navigate = useNavigate()
    const classes = useStyles()
    const [solicitacaoAnalise, setSolicitacaoAnalise] = useState('')
    const [avaliacaoAnalitica, setAvaliacaoAnalitica] = useState('')
    const [refresh, setRefresh] = useState(produtoId)
    const [habiliteThis, setHabiliteThis] = useState(false)

    useEffect(() => {
        api.get(`/solicitacao-analise/${id}`)
            .then(response => {
                // console.log(response);
                setSolicitacaoAnalise(response.data.solicitacaoAnalise);
            }).catch(err => {
                // console.log(err)
                // if (err?.response.status === 422) { navigate(-1) }
            })
    }, [id, refresh, alert])

    // console.log(habiliteThis)

    return (
        <Container>
            <RegisterAccess page={'gestão de solicitacao de análise'} />
            <HeaderSession title={'GESTÃO DE SOLICITAÇĀO DE ANÁLISE LABORATORIAL DE AMOSTRAS DE MEDICAMENTOS E TECNOLOGIAS DE SAÚDE'} />

            {solicitacaoAnalise ?
                <Grid container>

                    <Grid item className={classes.grid1} m>
                        <NavLateral
                            observacoesFeitas={solicitacaoAnalise?.observacoes}
                            solicitacaoAnalise={solicitacaoAnalise}
                            setHabiliteThis={setHabiliteThis}
                            avaliacaoAnalitica={avaliacaoAnalitica}
                            setAvaliacaoAnalitica={setAvaliacaoAnalitica}
                        />
                    </Grid>

                    <Grid xs item className={classes.grid2} m>

                        {React.cloneElement(component, {

                            solicitacaoAnalise: solicitacaoAnalise,
                            setSolicitacaoAnalise: setSolicitacaoAnalise,
                            setRefresh: setRefresh,
                            refresh: refresh,
                            habiliteThis: habiliteThis,
                            setHabiliteThis: setHabiliteThis,
                            setAvaliacaoAnalitica: setAvaliacaoAnalitica,
                            avaliacaoAnalitica: avaliacaoAnalitica
                        })}

                    </Grid>
                </Grid>
                :
                <ProcessoLoading />
            }
        </Container>

    )
}